import { render, staticRenderFns } from "./ReceivePcn.vue?vue&type=template&id=396cf6d1&scoped=true&"
import script from "./ReceivePcn.vue?vue&type=script&lang=js&"
export * from "./ReceivePcn.vue?vue&type=script&lang=js&"
import style0 from "./ReceivePcn.vue?vue&type=style&index=0&id=396cf6d1&prod&lang=css&"
import style1 from "./ReceivePcn.vue?vue&type=style&index=1&id=396cf6d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396cf6d1",
  null
  
)

export default component.exports